<template>
    <div class="report__builder_add">
        <div class="report__builder_add_header">
            <view-actions
                :title="'Report builder'"
                :cancel-notify-title-text="'Are you sure?'"
                :cancel-notify-content-text="'Do you want to cancel adding this report?'"
                :cancel-button-text="'Cancel'"
                :cancel-notify-active="true"
                :submit-button-active="false"
                @emit-notify-cancel-submit="reportStopEdit"
            />
        </div>
        <div class="report__builder_add_main">
            <div class="container">
                <div class="columns is-variable">
                    <div class="column">
                        <report-builder-edit-form></report-builder-edit-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ViewActions from '@/components/default/shared/ViewActions'
import ReportBuilderEditForm from '@/components/ebs/reports/builder/edit/ReportBuilderEditForm'
export default {
  name: 'report-builder-add',
  components: { ReportBuilderEditForm, ViewActions },
  methods: {
    allowRedirectBeforeRouteLeave () {
      this.$eventBus.$emit('report-builder-submit')
    },
    //
    reportStopEdit () {
      this.allowRedirectBeforeRouteLeave()
      this.$router.push({ name: 'ebs-report-list' })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/reports/_reportbuilder.scss";
</style>
